
import { useDispatch } from 'react-redux';
import './App.css';
import AppRoutes from './Routes/AppRoutes';
import { useEffect } from 'react';
import { saveUserRoleApi, signInCheckUserApi, signInUserApi, signUpUserApi, updateUserRoleApi, userDropDownApi, UserRolesApi } from './store/api/userAuthApi';
import { UnitsApi } from './store/api/UnitsApi';
import { supplierApi } from './store/api/supplierApi';
import { getLastRequestGenIdApi, RequestedMaterialsApi } from './store/api/RequestedMaterialsApi';
import { productsApi } from './store/api/productsApi';
import { orderProductApi } from './store/api/orderProductApi';
import { notificationsApi } from './store/api/notificationApi';
import { movementApi, productOrderApi } from './store/api/movementApi';
import { CreditPurchaseApi } from './store/api/creditPurchaseApi';
import { consumerApi } from './store/api/consumerApi';
import { categoryApi } from './store/api/categoryApi';
import { businessApi } from './store/api/businessApi';
const CACHE_CLEAR_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours

function App() {
  const dispatch = useDispatch();
  const apiActions = [
    signInUserApi,
    signInCheckUserApi,
    signUpUserApi,
    saveUserRoleApi,
    userDropDownApi,
    UserRolesApi,
    updateUserRoleApi,
    UnitsApi,
    supplierApi,
    RequestedMaterialsApi,
    getLastRequestGenIdApi,
    productsApi,
    orderProductApi,
    notificationsApi,
    movementApi,
    productOrderApi,
    CreditPurchaseApi,
    consumerApi,
    categoryApi,
    businessApi,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      apiActions.forEach(api => dispatch(api.util.resetApiState()));
    }, CACHE_CLEAR_INTERVAL);

    return () => clearInterval(interval);
  }, [dispatch]);


  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
